import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { Select } from 'foundations-components/transitional/components/Select';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectItemWithTooltip = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      use: option.use || 'danger',
      placement: option.placement || 'top',
      Content: option.tooltipContent,
      disabled: !option.disabled,
      children: children
    })
  }));
};
const TooltipSelect = props => /*#__PURE__*/_jsx(Select, Object.assign({
  itemComponent: SelectItemWithTooltip
}, props));
export default TooltipSelect;